export default __webpack_public_path__ + "images/referrals-onboarding-step-3.b57ec4a75038a9868011beb31fff8e68.png";